/**************************************************
 * Nombre:       Tarjetas_Indicador
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";


const Tarjetas_Indicador = ({item, index}) => {


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderBottom: 1, borderColor: '#00000030', pr: 2, mt: 2, pb: 2}}
            spacing={1}
        >


            <Grid container size={2}>
                <Typography
                    sx={{fontWeight: 600, lineHeight: 1.1, fontSize: 16}}>{`${item.numero}`}</Typography>
            </Grid>

            <Grid container size={10}>
                <Typography
                    sx={{fontWeight: 300, lineHeight: 1.1, fontSize: 14}}>{`${item.nombre}`}</Typography>
            </Grid>


        </Grid>
    )

}
export default Tarjetas_Indicador